module.exports = __webpack_public_path__ + "static/media/contact.ff1b858f.jpg";